import { useSelector, useDispatch } from 'react-redux';

import { transactionsActions } from 'companion-app-components/flux/transactions';
import type RootState from 'companion-app-components/utils/redux-store/rootState';
import { featureFlagsSelectors } from 'companion-app-components/flux/feature-flags';
import { scheduledTransactionsActions, scheduledTransactionsSelectors } from 'companion-app-components/flux/scheduled-transactions';
import { accountsSelectors } from 'companion-app-components/flux/accounts';

import * as transactionsSelectors from 'data/transactions/selectors';

import { scheduledTransactionLightEditDialog } from 'components/Dialogs/ScheduledTransactionLightEditDialog/actions';

export const useSelectOrDispatch = (props) => {
  const dispatch = useDispatch();
  const scheduledTransactionsEnabled = useSelector((state: RootState) => featureFlagsSelectors.getFeatureFlag(state, 'scheduledTransactions'));
  const scheduledTransactions = useSelector((state: RootState) => scheduledTransactionsSelectors.getUserVerifiedScheduledTransactions(state));
  const scheduledTransactionByClientId = useSelector((state: RootState) => scheduledTransactionsSelectors.getScheduledTransactionByClientId(state, props.uiState.newScheduledTransactionClientId));
  const scheduledTransactionById = useSelector((state: RootState) => scheduledTransactionsSelectors.getScheduledTransactionById(state, props.txForm.stModelId));
  const scheduledTransaction = props.uiState.newScheduledTransactionClientId ? scheduledTransactionByClientId : scheduledTransactionById;
  const scheduledTransactionsError = useSelector((state: RootState) => scheduledTransactionsSelectors.getError(state));
  const transactionsError = useSelector((state: RootState) => transactionsSelectors.getError(state));
  const transactionDetailsComprehensive = useSelector((state: RootState) => featureFlagsSelectors.getFeatureFlag(state, 'transactionDetailsComprehensive'));
  const showTxnJson = useSelector((state: RootState) => featureFlagsSelectors.getFeatureFlag(state, 'showTxnJson'));
  const coaBucket = useSelector((state: RootState) => transactionsSelectors.getTransactionBucket(state, props.txForm));
  const txnsByAccountId = useSelector((state: RootState) => transactionsSelectors.getTransactionsByAccountId(state));
  const accountIds = useSelector(accountsSelectors.getAccountsById);
  
  return {
    scheduledTransactionsEnabled,
    scheduledTransactions,
    scheduledTransaction,
    scheduledTransactionsError,
    transactionsError,
    transactionDetailsComprehensive,
    showTxnJson,
    coaBucket,
    txnsByAccountId,
    accountIds,
    dispatchDeleteScheduledTransactionAction: (data) => dispatch(scheduledTransactionsActions.deleteScheduledTransaction(data)),
    dispatchCreateBillScoutScheduleAction: (data) => dispatch(scheduledTransactionsActions.createBillScoutSchedule(data)),
    dispatchPerformTransactionAction: (data, meta) => dispatch(transactionsActions.performTransactionAction(data, meta)),
    dispatchScheduledEditLightDialog: (data) => dispatch(scheduledTransactionLightEditDialog(data)),
  };
};
